module.exports = __webpack_public_path__ + "img/table1-bg.4951cd8b.svg";